<template>
    <div class="file-thumb" v-html="document.thumb"  @click.prevent="openFile"></div>
</template>

<script>
export default {
    name: "ThumbOverview",
    props: {
        document: { type:Object, required:true }
    },
    methods: {
        openFile() {
            if(this.document.type == 'file') {
                window.open(this.document.cached_file, '_blank');

                return;
            }

            window.open(this.document.external_file, '_blank');
        }
    }
}
</script>

<style scoped>
.file-thumb {
    display: flex;
    align-items: center;
    justify-content: center;
    width:100px;
    height:100px;
    cursor: pointer;
}
::v-deep img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
::v-deep .fa {
    font-size: 1.2rem;
}
</style>
